<template>
  <div class="referral-page">
    <page-title :title="$t('components.main.navigation.referral-page')" :bordered="true" />
    <referral-hero-banner />
    <div class="d-grid gap-20 gap-sm-30 gap-lg-40 mt-20 mt-md-30 mt-lg-40">
      <div class="px-20 px-md-30">
        <referral-contents :contents="referralContents" />
      </div>
      <div class="refer-now-and-instructions">
        <div class="px-20 px-md-30">
          <referral-step-instructions :contents="stepByStepContents" />
          <refer-now-referral class="py-20 py-md-30 py-lg-40" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReferralHeroBanner from '~/components/referral/hero-banner.vue'
  import ReferralContents from '~/components/referral/contents.vue'
  import ReferNowReferral from '~/components/referral/refer-now-referral'
  import ReferralStepInstructions from '~/components/referral/step-instructions.vue'
  import PageTitle from '~/components/shared/page-title.vue'

  export default {
    name: 'referral-page',

    components: {
      PageTitle,
      ReferralContents,
      ReferNowReferral,
      ReferralHeroBanner,
      ReferralStepInstructions,
    },

    data() {
      return {
        contents: [],
      }
    },

    computed: {
      getAmount() {
        return this.$store.getters['multiCurrency/get_referral_get_amount']
      },

      referralContents() {
        return this.contents
          .filter((item) => !item.key.includes('step-by-step'))
          .map((v, i) => ({
            ...v,
            reverse: i % 2 === 1,
            img: `/assets/images/referral/referral-page-content-${i + 1}.svg`,
          }))
      },

      stepByStepContents() {
        return this.contents
          .filter((item) => item.key.includes('step-by-step'))
          .map((v, i) => ({
            ...v,
            img: `/assets/images/referral/referral-page-instructions-${i + 1}.svg`,
          }))
      },
    },

    head() {
      return {
        title: this.$te('seo.referral.title') ? this.$t('seo.referral.title') : this.$t('seo.homepage.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.referral.description.v2', { amount: this.getAmount }),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.referral.keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.referral.title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.referral.description.v2', { amount: this.getAmount }),
          },
        ],
      }
    },

    created() {
      const joinKeys = (keys, addBr) => keys.join(addBr ? '<br /><br />' : ' ')

      this.contents = [
        //  This content was previously stored in Contents section in Admin Panel, hence the 'key' property
        //  It can't be created directly in data() because the MC getter is still unavailable at that time.
        //  Multiple keys for a single content are used so that Crowdin translations match better (sync'ed with Mísa).
        {
          title: this.$t('scenes.content.referral-page.why-airalo-referral-title'),
          content: joinKeys(
            [
              this.$t('scenes.content.referral-page.why-airalo-referral-content-1'),
              this.$t('scenes.content.referral-page.why-airalo-referral-content-2'),
            ],
            false
          ),
          key: 'why-airalo-referral',
        },
        {
          title: this.$t('scenes.content.referral-page.how-does-referral-program-work-title'),
          content: this.$t('scenes.content.referral-page.how-does-referral-program-work-content', {
            getAmount: this.getAmount,
            giveAmount: this.getAmount,
          }),
          key: 'how-does-referral-program-work',
        },
        {
          title: this.$t('scenes.content.referral-page.step-by-step-instructions-1-title'),
          content: this.$t('scenes.content.referral-page.step-by-step-instructions-1-content'),
          key: 'step-by-step-instructions-1',
        },
        {
          title: this.$t('scenes.content.referral-page.step-by-step-instructions-2-title'),
          content: joinKeys(
            [
              this.$t('scenes.content.referral-page.step-by-step-instructions-2-content-1'),
              this.$t('scenes.content.referral-page.step-by-step-instructions-2-content-2'),
            ],
            false
          ),
          key: 'step-by-step-instructions-2',
        },
        {
          title: this.$t('scenes.content.referral-page.step-by-step-instructions-3-title', { amount: this.getAmount }),
          content: this.$t('scenes.content.referral-page.step-by-step-instructions-3-content', {
            amount: this.getAmount,
          }),
          key: 'step-by-step-instructions-3',
        },
        {
          title: this.$t('scenes.content.referral-page.step-by-step-instructions-4-title', { amount: this.getAmount }),
          content: joinKeys(
            [
              this.$t('scenes.content.referral-page.step-by-step-instructions-4-content-1', { amount: this.getAmount }),
              this.$t('scenes.content.referral-page.step-by-step-instructions-4-content-2'),
              this.$t('scenes.content.referral-page.step-by-step-instructions-4-content-3'),
            ],
            false
          ),
          key: 'step-by-step-instructions-4',
        },
        {
          title: this.$t('scenes.content.referral-page.step-by-step-instructions-5-title'),
          content: joinKeys(
            [
              this.$t('scenes.content.referral-page.step-by-step-instructions-5-content-1'),
              this.$t('scenes.content.referral-page.step-by-step-instructions-5-content-2'),
            ],
            false
          ),
          key: 'step-by-step-instructions-5',
        },
      ]
    },
  }
</script>

<style lang="scss" scoped>
  .refer-now-and-instructions {
    background-color: #fff;
  }
</style>
